import { Link, Typography } from '@material-ui/core';
import { formatDate } from '@superdispatch/dates';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { InstantTransferPriceInformation } from 'shared/modules/superpay/instant-transfer/InstantTransferPriceInformation';
import { SuperPayInstantTransferConfirmDTO } from 'shared/modules/superpay/SuperPayDTO';
import styled from 'styled-components';

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferPending({
  onClose,
  dialogConfirmInformation,
}: {
  onClose: () => void;
  dialogConfirmInformation: SuperPayInstantTransferConfirmDTO;
}) {
  const { load_id, sent_date, bank_account } = dialogConfirmInformation;

  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Stack space="medium">
        <Box padding="medium" backgroundColor="Green50">
          <Stack space="medium">
            <Box color="Green300">
              <Stack space="xxsmall">
                <Typography variant="h2">
                  Hang Tight—Your Payment Is on the Way
                </Typography>
                <Typography>
                  We’ve sent your payment, but depending on your bank, it may
                  take up to 30 minutes to appear. Still waiting? Contact us at{' '}
                  <Link href="mailto:support@superdispatch.com">
                    support@superdispatch.com
                  </Link>
                </Typography>
              </Stack>
            </Box>
            {sent_date && (
              <Stack space="xxsmall">
                <Typography color="textSecondary">Date Sent</Typography>
                <Typography>
                  {formatDate(String(sent_date), {
                    variant: 'DateTime',
                    fallback: '',
                  })}
                </Typography>
              </Stack>
            )}
            <Stack space="xxsmall">
              <Typography color="textSecondary">Account</Typography>
              <Typography>{bank_account}</Typography>
            </Stack>
            <Stack space="xxsmall">
              <Typography color="textSecondary">Load ID</Typography>
              <Typography>{load_id}</Typography>
            </Stack>
          </Stack>
        </Box>
        <InstantTransferPriceInformation
          data={dialogConfirmInformation}
          totalTitle="Payment Amount"
        />
      </Stack>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
